import styled, { css } from 'styled-components';
import { pxToRem } from '../../../../../design-tokens/style-utilities';
const linkBlockIconStyles = ({ theme }) => css `
	flex: none;
	display: block;
	padding: ${pxToRem(theme.spacing['100'])};
	border-radius: ${pxToRem(theme.borderRadius.m)};
	background-color: ${theme.colors.accent.bgStickerInformative};
	color: ${theme.colors.base.iconIllustrative};
`;
export const StyledLinkBlockIcon = styled.span `
	${linkBlockIconStyles}
`;
